export default "__VITE_PUBLIC_ASSET__6318d894__"